const accordionContents = document.querySelectorAll(
	'.block-accordion-side-image__content'
);

const resizeGrid = () => {
	if (accordionContents.length) {
		accordionContents.forEach((accordionContent) => {
			accordionContent.style.removeProperty('--marginTop');
			accordionContent.nextElementSibling.style.removeProperty(
				'--marginTop'
			);

			const offset =
				accordionContent.offsetTop -
				accordionContent.nextElementSibling.offsetTop;

			if (offset > 0) {
				accordionContent.style.setProperty(
					'--marginTop',
					`${offset}px`
				);
			} else {
				accordionContent.style.setProperty('--marginTop', `0px`);
			}
		});
	}

	// Check if the screen size is greater than 768
	if (window.innerWidth > 768) {
		const blockTabsSideImageSections = document.querySelectorAll(
			'.block-tabs-side-image'
		);
		blockTabsSideImageSections.forEach((section) => {
			const figureElement = section.querySelector(
				'.block-tabs-side-image-tab__figure'
			);
			const controlsWrapperElement = section.querySelector(
				'.block-tabs-side-image__controls-wrapper'
			);
			const contentElements = section.querySelectorAll('.block-content');

			if (figureElement && controlsWrapperElement && contentElements) {
				// Get padding-top of .block-tabs-side-image-tab__figure
				const figurePaddingTop = window
					.getComputedStyle(figureElement)
					.getPropertyValue('padding-top');

				// Convert padding-top value to integer (remove 'px')
				const figurePaddingTopInt = parseInt(
					figurePaddingTop.replace('px', ''),
					10
				);

				// Get the height of .block-tabs-side-image__controls-wrapper
				const controlsWrapperHeight =
					controlsWrapperElement.offsetHeight;

				// Calculate the top value
				const topValue =
					figurePaddingTopInt + controlsWrapperHeight + 30;

				// Apply the top value to all .block-content elements in this section
				contentElements.forEach((contentElement) => {
					contentElement.style.top = `${topValue}px`;
				});
			}
		});
	}
};

const accordions = () => {
	if (accordionContents.length) {
		resizeGrid();
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		accordions();
	},
	loaded() {
		resizeGrid();
	},
	resized() {
		resizeGrid();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
